var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-seamless-scroll',{staticClass:"seamless-warp2",attrs:{"data":_vm.newsList,"class-option":_vm.optionLeft}},[_c('ul',{staticClass:"item"},_vm._l((_vm.newsList),function(item,i){return _c('li',{key:i,domProps:{"textContent":_vm._s(item.title)}})}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-6bf664f4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/view/page/screen3.vue
// module id = null
// module chunks = 